<template>
    <div class="user-group-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.id.toString()"
                :length="1"
            >
            </colored-letter-square>

            <div slot="courses" slot-scope="props">
                {{ props.row.courses.join(', ') }}
            </div>

            <div slot="actions" slot-scope="props">
                <WbtConfigTableActions
                    :data="props.row"
                    :index="props.index"
                ></WbtConfigTableActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    props: ['client'],

    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'courses', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    courses: this.trans('wbt_configs.label.courses'),
                    actions: this.trans('vuetables.label.actions')
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },

                sortable: ['name']
            }
        };
    },

    created() {
        this.fetch();
    },

    methods: {
        fetch() {
            axios
                .get(
                    this.route(
                        'tenantapi.clients.wbt-configs.index',
                        this.client.id
                    )
                )
                .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        }
    },

    mounted() {
        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    }
};
</script>
